import { updateOrRemove } from '../utils';
import { defineTransform } from '../transform';
import { transformOpRange } from '../transformCursor';

import { Editor } from 'slate';

function AddAnnotationTransform(editor, op) {
  const {
    annotation: { key, range, ...otherProps },
  } = op;

  if (!editor.metadata) {
    editor.metadata = {
      annotations: {},
    };
  } else if (!editor.metadata.annotations) {
    editor.metadata.annotations = {};
  }

  editor.metadata.annotations[key] = {
    key,
    range: Editor.rangeRef(editor, range, { affinity: 'inward' }),
    ...otherProps,
  };
}

export default AddAnnotationTransform;
function transformAnnotation(annotationOp, op) {
  return transformOpRange(annotationOp, 'annotation', op);
}

defineTransform('add_annotation', 'insert_text', (op1, op2, side) => {
  return transformAnnotation(op1, op2);
});

defineTransform('add_annotation', 'remove_text', (op1, op2, side) => {
  return transformAnnotation(op1, op2);
});

defineTransform('add_annotation', 'split_node', (op1, op2, side) => {
  return transformAnnotation(op1, op2);
});

defineTransform('add_annotation', 'merge_node', (op1, op2, side) => {
  return transformAnnotation(op1, op2);
});

defineTransform('add_annotation', 'move_node', (op1, op2, side) => {
  return transformAnnotation(op1, op2);
});

defineTransform('add_annotation', 'insert_node', (op1, op2, side) => {
  return transformAnnotation(op1, op2);
});

defineTransform('add_annotation', 'remove_node', (op1, op2, side) => {
  return transformAnnotation(op1, op2);
});

defineTransform('add_annotation', 'set_node', (op1, op2, side) => {
  return transformAnnotation(op1, op2);
});

defineTransform('add_annotation', 'add_mark', (op1, op2, side) => {
  return transformAnnotation(op1, op2);
});

defineTransform('add_annotation', 'remove_mark', (op1, op2, side) => {
  return transformAnnotation(op1, op2);
});

defineTransform('add_annotation', 'set_mark', (op1, op2, side) => {
  return transformAnnotation(op1, op2);
});

defineTransform('add_annotation', 'set_selection', (op1, op2, side) => {
  return transformAnnotation(op1, op2);
});

defineTransform('add_annotation', 'add_annotation', (op1, op2, side) => {
  if (op1.annotation.key !== op2.annotation.key) return op1;

  // If two adds conflict, the winner will ignore the second one, and
  // the loser will run a set_annotation operation to replace itself
  // with the winning one.
  if (side !== 'left') return [];

  let tOp = {
    type: 'set_annotation',
    properties: {
      ...op2.annotation,
    },
    newProperties: {
      ...op1.annotation,
    },
  };

  tOp = updateOrRemove(tOp, ['data', 'properties'], op2.data?.annotation);
  tOp = updateOrRemove(tOp, ['data', 'newProperties'], op1.data?.annotation);
  return tOp;
});

defineTransform('add_annotation', 'remove_annotation', (op1, op2, side) => {
  if (op1.annotation.key !== op2.annotation.key) return op1;

  // add vs remove always defers to the remove.
  return [];
});

defineTransform('add_annotation', 'set_annotation', (op1, op2, side) => {
  if (op1.annotation.key !== op2.properties.key) return op1;

  // add vs set always defers to the set.
  return [];
});
